import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LedgerArray } from '@pos-app/data';

@Component({
  selector: 'app-schedule-history-notes',
  templateUrl: './schedule-history-notes.component.html',
  styleUrls: ['./schedule-history-notes.component.scss'],
})
export class ScheduleHistoryNotesComponent implements OnInit {
  @Input() ledgerResultArray: Array<LedgerArray>;
  @Output() closeActiveNoteModal = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns = [
    'updateDate',
    'updateTime',
    'updateUser',
    'deleteYN',
    'startDate',
    'startTime',
    'endTime',
    'scheduledHours',
    'resourceList',
    'description',
  ];
  dataSource: MatTableDataSource<LedgerArray>;

  constructor() {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource<LedgerArray>(this.ledgerResultArray);
  }

  formatTime(time) {
    // JDE time doesn't put a 0 at the start when less than 10am
    if (parseInt(time.slice(0, 2)) > 24) {
      return ['0' + time.slice(0, 1), ':', time.slice(1, 3)].join('');
    } else {
      return [time.slice(0, 2), ':', time.slice(2, 4)].join('');
    }
  }
  formatTimeWithSec(time) {
    // JDE time doesn't put a 0 at the start when less than 10am
    if (parseInt(time.slice(0, 2)) > 24) {
      return ['0' + time.slice(0, 1), ':', time.slice(1, 3), ':', time.slice(3, 5)].join('');
    } else {
      return [time.slice(0, 2), ':', time.slice(2, 4), ':', time.slice(4, 6)].join('');
    }
  }

  closeModala() {
    this.closeActiveNoteModal.emit(true);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
}
